import type { AppDispatch } from '../../configureStore'
import { clearModal as clearModalAction } from '../../slices/modal.slice'

export type ModalClearAction = {
  type: 'MODAL_CLEAR'
}

export const clearModal = (dispatch: AppDispatch) => () => {
  dispatch(clearModalAction())
}
